<template>
  <div class="row">
    <div class="col-md-12 mt50">

      <div v-if="loading">
        <div class="col-md-12 center">
          <div class="loading"><img src="@/assets/img/loading.gif" alt=""></div>
        </div>
      </div>

      <template v-else>
        <div v-if="proyectos" class="row">
          <div class="col-md-8">
            <h4>{{ $t('Por proyecto') }}</h4>
          </div>
          <div class="col-md-4">
            <div v-if="proyectos" class="download-excel align-right mb10">
              <a :href="getApiUrl + getLocale + '/' + enlace_excel" class="buy-link todo" target="_blank"><i class="fa fa-file-excel-o"></i> {{ $t('Guardar') }} EXCEL</a>
            </div>
          </div>
        </div>

        <table v-if="filteredData" class="table table-hover"> 
          <thead> 
            <tr> 
              <th width=" 2%">#</th>
              <th width="68%" @click="sortBy('proyecto')">{{ $t('Proyecto') }} <i class="fa fa-sort"></i></th>
              <th width="10%" @click="sortBy('asignado')" class="align-right">{{ $t('Asignado') }} <i class="fa fa-sort"></i></th> 
              <th width="10%" @click="sortBy('recibido')" class="align-right">{{ $t('Recibido') }} <i class="fa fa-sort"></i></th> 
              <th width="10%" @click="sortBy('diferencia')" class="align-right">{{ $t('Diferencia') }} <i class="fa fa-sort"></i></th>     
            </tr> 
          </thead> 
          <tbody> 
            <tr v-for=" (item, index) in filteredData "> 
              <th>{{ index + 1 }}</th>
              <td>{{ item.proyecto }}</td> 
              <td class="align-right">{{ toCurrency(item.asignado) }}</td> 
              <td class="align-right">{{ toCurrency(item.recibido) }}</td> 
              <td class="align-right">{{ toCurrency(item.diferencia) }}</td>
            </tr> 
          </tbody> 
        </table>
      </template>
    </div>
  </div>
</template>

<i18n>
{
  "es": {
    "Por proyecto": "Por proyecto",
    "Proyecto": "Proyecto",
    "Asignado": "Asignado",
    "Recibido": "Recibido",
    "Diferencia": "Diferencia",
    "Proyecto": "Proyecto",
    "Guardar": "Guardar"
  },
  "en": {
  },
  "ca": {
    "Por proyecto": "Per projecte",
    "Proyecto": "Projecte",
    "Asignado": "Assignat",
    "Recibido": "Rebut",
    "Diferencia": "Diferència",
    "Proyecto": "Projecte"
  }
}
</i18n>

<script>
  import axios from 'axios'; 
  import { mapGetters } from 'vuex';

  export default {
    data: () => {
      return{
        proyectos: [],
        enlace_excel: '',
        error: false,
        error_message: '',
        loading: false,
        sortKey: '',
        sortOrders: { proyecto: 1, asignado: 1, recibido: 1, diferencia: 1 }
      }
    },
    created(){
      this.cargarProyectos();
    },
    mounted(){
    },
    computed:{
      ...mapGetters(['getLocale', 'getApiUrl']),
      filteredData: function () {
        var sortKey = this.sortKey
        var order = this.sortOrders[sortKey] || 1
        var data = this.proyectos
        if (sortKey) {
          data = data.slice().sort(function (a, b) {
            a = a[sortKey]
            b = b[sortKey]
            return (a === b ? 0 : a > b ? 1 : -1) * order
          })
        }
        return data
      } 
    },
    methods: {
      cargarProyectos() {
        this.success = false;
        this.error = false;
        this.showLoading();

        axios.get(this.getApiUrl + this.getLocale + '/misconsultas/proyecto')       
          .then( (respuesta) =>{ 

            console.log(respuesta);
            this.enlace_excel = respuesta.data.data.enlace_excel;
            this.proyectos = respuesta.data.data.proyectos;
            this.hideLoading();

          })
        .catch( (error) =>{ 
          //this.proyectos = '';
          this.hideLoading();
          //console.log(error);
          //this.error_message = error.response.data.msg;
          this.error = true;
        });

      },
      showLoading(){ this.loading = true; },
      hideLoading(){ this.loading = false; },
      sortBy(key){
        this.sortKey = key;
        this.sortOrders[key] = this.sortOrders[key] * -1;
      },
    },
    watch:{
    }
  }
</script>
